var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',_vm._l((_vm.accordions),function(accordion){return _c('AccordionText',{key:accordion.id,attrs:{"id":accordion.id,"title":accordion.title,"text":accordion.text}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }